import { useAuthStore } from '@/store/useAuthStore';
import { useAdDetails } from '@/views/Ads/useAdDetails';

export function useIsAuthor() {
  const { userId } = useAuthStore(state => state);
  const { adDetails } = useAdDetails();
  return userId === adDetails?.user?.id;
}
